import { BaseError } from '@kiplin/web-common/error';

export class MissingCommunicationKitTemplateError extends BaseError {
  constructor() {
    super('1fd06243-6dad-4043-a4d6-2edcfd0126be', 'Missing selected communication kit template');
  }
}
